import { Inject, Injectable } from '@angular/core';
import { QueryService } from 'src/app/core/services/query.service';
import { CrudService } from 'src/app/core/services/crud.service';
import { ApiService } from 'src/app/core/services/api.service';
import { SnackbarService } from 'src/app/core/services/snackbar-psa.service';
import { IPageEvent } from 'src/app/core/models/paginator.model';
import { COORDINATE_ENDPOINT, COORDINATE_QUERY_SERVICE_INSTANCE } from 'src/app/config/coordinate.config';

@Injectable({
  providedIn: 'root'
})
export class CoordinateService extends CrudService<any>{

  constructor(
      @Inject(COORDINATE_QUERY_SERVICE_INSTANCE) public readonly query: QueryService<any>,
      public readonly apiService: ApiService,
      protected  override readonly snackbar : SnackbarService
    ) {
      super(COORDINATE_ENDPOINT, apiService, snackbar);
    }


    getAllFiltered(parameter: IPageEvent, searchData?: any, filters?: Record<string, any>) {
        const stringSearch = searchData || '';
        let queryParams: string[] = [];

        const processFilter = (keyPrefix: string, value: any) => {
            if (value === null || value === undefined) return;
            if (Array.isArray(value)) {
                const fv = `${keyPrefix}||in||${value.join(',')}`;
                queryParams.push(`filter=${encodeURIComponent(fv)}`);
            } else if (typeof value === 'object') {
                Object.keys(value).forEach(k => {
                    processFilter(`${keyPrefix}.${k}`, value[k]);
                });
            } else {
                const fv = `${keyPrefix}||eq||${value}`;
                queryParams.push(`filter=${encodeURIComponent(fv)}`);
            }
        };
        if (filters) {
            Object.keys(filters).forEach(key => {
                if (key.includes('_from')) {
                    const fv = `${key.split('_from')[0]}||gte||${filters[key]}`;
                    queryParams.push(`filter=${encodeURIComponent(fv)}`);
                } else if (key.includes('_to')) {
                    const fv = `${key.split('_to')[0]}||lte||${filters[key]}`;
                    queryParams.push(`filter=${encodeURIComponent(fv)}`);
                } else {
                    processFilter(key, filters[key]);
                }
            });
        }
        queryParams.push(`page=${parameter.pageIndex}`);
        queryParams.push(`limit=${parameter.pageSize}`);
        if (searchData) queryParams.push(`search=${stringSearch}`);

        const queryString = queryParams.length > 0 ? `?${queryParams.join('&')}` : '';
        return this.apiService.get(COORDINATE_ENDPOINT + queryString);
    }

}